import { Id } from '@silevis/reactgrid'

const getDescendantIds = (id: Id, array: { rowId: Id; parentId?: Id }[]): Id[] => {
  const childIds = array.filter((row) => row.parentId === id).map((row) => row.rowId)
  return [...childIds, ...childIds.flatMap((id) => getDescendantIds(id, array))]
}

export default getDescendantIds
